import { Link, useLocation } from 'react-router-dom';

const TermGuidelineCategory = () => {
  const location = useLocation();
  
  const categories = [
    { key: 'single', label: 'シングルカード', path: '/terms/quality_guideline_non_psa' },
    { key: 'box', label: '未開封ボックス', path: '/terms/quality_guideline_box' },
    { key: 'psa', label: 'PSA', path: '/terms/quality_guideline_psa' },
    { key: 'unopened', label: '未開封カード', path: '/terms/quality_guideline_unopened_card' },
    { key: 'pack', label: '未開封パック', path: '/terms/quality_guideline_unopened_pack' },
    { key: 'hobby', label: 'フィギュア・ホビー', path: '/terms/quality_guideline_figure_hobby' },
  ];

  return (
    <div className="w-full bg-white flex flex-col justify-start items-start gap-5">
      <div className="w-full h-9 px-[5px] inline-flex justify-start items-center gap-2.5">
        <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
        <div className="justify-center text-black text-2xl font-bold leading-9">カテゴリ</div>
      </div>
      <div className="w-full grid grid-cols-1 gap-2.5 min:grid-cols-3 mid:grid-cols-3 max:grid-cols-3">
        {categories.map(({ key, label, path }) => {
          const isCurrentPage = location.pathname === path;
          
          if (isCurrentPage) {
            return (
              <div
                key={key}
                className="w-full px-1 py-5 bg-[#e4e4e4] rounded-[10px] flex justify-center items-center"
              >
                <div className="text-center text-xl font-bold leading-[30px] text-[#aaaaaa]">
                  {label}
                </div>
              </div>
            );
          }
          
          return (
            <Link
              key={key}
              to={`${path}${location.search}`}
              className="w-full px-1 py-5 bg-[#fbe0c9] rounded-[10px] flex justify-center items-center transition-colors hover:bg-[#f5d1b3]"
            >
              <div className="text-center text-xl font-bold leading-[30px] text-black">
                {label}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default TermGuidelineCategory;
